import { IPropsSVGType } from '#types/svg.types';
import SVG from './SVG.styled';

export default function InfoPriceHistory({
  width = '24',
  height = '24',
  color = 'main-orange',
  viewBox = '-12 0 24 25',
  stroke,
  hover,
  isHover,
  isActive,
}: IPropsSVGType) {
  return (
    <SVG
      $color={color}
      $hover={hover}
      $isHover={isHover}
      $isActive={isActive}
      $stroke={isActive ? "var(--main-orange)" : `var(${stroke})` || 'var(--main-color)'}
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M7.19291 6.61303C9.01537 6.4537 10.3642 4.84667 10.2038 3.02426C10.0455 1.2018 8.43856 -0.146542 6.6161 0.0127846C4.79364 0.17216 3.44476 1.7786 3.60409 3.60107C3.76351 5.42465 5.37049 6.7724 7.19291 6.61303Z" />
        <path d="M8.20063 19.8407C7.41284 20.1291 6.0853 20.9416 6.0853 20.9416C6.0853 20.9416 7.09189 16.2884 7.13344 16.0859C7.55873 14.0434 8.76738 11.161 7.13007 9.40875C5.98994 8.19117 4.52431 8.51886 3.23266 9.75441C2.37978 10.5696 1.92753 11.0909 1.13754 11.9674C0.817719 12.3225 0.696527 12.6542 0.847992 13.1743C1.01069 13.7365 1.6683 14.0154 2.2496 13.8027C3.0374 13.5149 4.36386 12.7025 4.36386 12.7025C4.36386 12.7025 3.74887 15.5343 3.44252 16.9505C3.39985 17.1525 1.68178 22.4823 3.32021 24.2347C4.46035 25.4529 5.92485 25.1246 7.21762 23.8897C8.0705 23.0743 8.52275 22.5531 9.31274 21.6761C9.63256 21.3214 9.75263 20.9899 9.60229 20.4697C9.43842 19.9081 8.78193 19.6286 8.20063 19.8407Z" />
    </SVG>
  );
}
